
<div  class="val-barre-navigation-version-libelle val-couleur-texte"
      [ngClass]="{'val-invisible': masque}">
  {{ 'valcomposantslib.barre-navigation.version.version' | transloco:{version: versionApplication} }}
  @if (!masquerReleaseNotes)
  {
    -
    <div class="val-barre-navigation-version-lien-notes"
          title="{{ 'valcomposantslib.barre-navigation.version.infobulle' | transloco }}"
          (click)="NotesClick()">
      {{ 'valcomposantslib.barre-navigation.version.notes' | transloco }}
  </div>
  }
</div>

<val-boite-dialogue-generique #boiteDialogue
                              class="val-barre-navigation-version-boite-dialogue"
                              titre="{{ 'valcomposantslib.barre-navigation.version.dialogue' | transloco }}"
                              validerVisible="false"
                              (annulerClick)="FermerNotes()">
  <div contenu
       class="val-barre-navigation-version-boite-dialogue-contenu val-flex-conteneur val-flex-colonne">

      @for (item of releaseNotes; track $index) 
      {
        <val-simple-panel>
          <div class="val-barre-navigation-version-boite-dialogue-version val-couleur-titre">{{item.version}}</div>
          <div class="val-barre-navigation-version-boite-dialogue-description val-couleur-fond-page">
            {{item.description}} 
            @if (item.numeroInterne){
              <span class="val-barre-navigation-version-boite-dialogue-numero val-couleur-titre">(#{{item.numeroInterne}})</span>
            }
          </div>
        </val-simple-panel>
      }

  </div>

</val-boite-dialogue-generique>
